import { DefaultImageDirective } from './directives/imagePreload/image-preload.directive';
import { CustomClipboard } from './services/clipboard/clipboard.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WindowScrollService } from './services/window-scroll.service';
import { GeralService } from './services/geral-service/geral-service';
import { FeatureToggleDirective } from './directives/feature-toggle/feature-toggle.directive';
import { FormatPhoneDDIPipe } from './pipes/format-phone-ddi.pipe';
import { RouteGuardService } from './guards/route-guard/service/route-guard.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    WindowScrollService,
    GeralService,
    RouteGuardService,
    CustomClipboard
  ],
  declarations: [FeatureToggleDirective, FormatPhoneDDIPipe, DefaultImageDirective],
  exports: [FeatureToggleDirective, FormatPhoneDDIPipe, DefaultImageDirective]
})
export class CoreModule { }
